import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import ThreatFrameworks from "./ThreatFrameworks";
import firebase from "firebase/compat/app";
import RiskIdentificationLab from "./components/RiskIdentificationLab";

const Chapter7_2 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question:
        "Frage 1: Was ist ein sinnvoller erster Schritt zur Risikoidentifikation in der Cybersecurity?",
      options: [
        {
          value: "A",
          label:
            "Zuerst klären, welche Systeme/Daten/Prozesse kritisch sind und wo sie liegen – erst dann mögliche Bedrohungen und Schwachstellen dazu sammeln.",
        },
        {
          value: "B",
          label: "Direkt mit einer Liste bekannter Hacker-Gruppen starten und daraus ableiten, welche Risiken das Unternehmen hat.",
        },
      ],
      correct: "A",
    },
    {
      question:
        "Frage 2: Welche Aussage beschreibt Risikoidentifikation am besten?",
      options: [
        {
          value: "A",
          label:
            "Risikoidentifikation ist ein fortlaufender Prozess, der regelmäßig aktualisiert werden muss. ",
        },
        {
          value: "B",
          label:
            "Risikoidentifikation ist ein einmaliger Schritt zu Projektbeginn; wenn die Liste steht, bleibt sie im Wesentlichen gültig und muss nicht mehr angepasst werden.",
        },
      ],
      correct: "A",
    },
  ];

  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/cybersecurity/login"); 
      }
    });

   
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 7_2.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("cybersecurityProgress").doc(userId).get();

        console.log("userDoc:", userDoc.exists); 

        if (userDoc.exists) {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .update({
              lastChapter: "7_2",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("7_2"),
            });
          console.log("Dokument aktualisiert mit Kapitel 7_2.");
        } else {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .set({
              lastChapter: "7_2",
              completedChapters: ["7_2"],
            });
          console.log("Dokument erstellt mit Kapitel 7_2");
        }

        navigate("/cybersecurity/7_3"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/cybersecurity/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/cybersecurity/course-overview"
                >
                  7. IT-Risikomanagement 
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Risikoidentifikation
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">
            Kapitel 7: IT-Risikomanagement 
          </h3>
          <h2 className="text-center pb-5">Risikoidentifikation </h2>
          <img
            src="/images/risikouberwachung.png"
            alt="Überwachung"
            style={{ position: "relative", maxWidth: "10%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <h3 className="p-5">Identifikation von Risiken</h3>

              <p className="col-lg-11 mx-auto">
              Ein effizientes Risikomanagement folgt einem strukturierten Ansatz,
              der mehrere wesentliche Schritte umfasst: die Identifikation von
              Risiken, ihre Bewertung inklusive Priorisierung sowie die Auswahl und
              Umsetzung geeigneter Maßnahmen.
              <br />
              <br />
              Die Identifikation von Risiken ist der erste Schritt im Risikomanagementprozess. In dieser Phase werden
              potenzielle Gefahren, Schwachstellen und Bedrohungen aufgedeckt,
              die die Sicherheit und Stabilität eines Unternehmens gefährden
              könnten. Ziel ist es, alle relevanten Risiken systematisch zu
              erfassen und zu dokumentieren, um sie anschließend bewerten und
              steuern zu können.
           
              
            </p>
          </div>
     
     


          <div className="gelb-section">
          <div className="container p-5">
            <div className="p-5 ">
              <p className="col-lg-11 mx-auto">
                Zur Identifikation von Risiken stehen verschiedene Methoden zur
              Verfügung, die je nach Situation kombiniert eingesetzt werden
              können: <br />
                <br />
                <strong>Interviews und Workshops: </strong>
                <br />
                Mitarbeiter aus verschiedenen Abteilungen teilen ihre
                Perspektiven, um mögliche Schwachstellen und Bedrohungen
                aufzudecken. <br />
                <br />
                <strong>Checklisten: </strong>
                <br />
                Standardisierte Fragen helfen, häufige Risiken strukturiert zu
                erfassen. <br />
                <br />
                <strong>
                  Schwachstellen-Scans und{" "}
                  <Link to="/cybersecurity/2_1#pentest" className="icon-link">
                    <svg className="bi" aria-hidden="true">
                      <use xlinkHref="#book"></use>
                    </svg>{" "}
                    Penetrationstests:
                  </Link>
                </strong>
                <br />
                Technische Tools prüfen IT-Systeme und Netzwerke auf
                Sicherheitslücken. <br />
                <br />
                <strong>Analyse vergangener Vorfälle: </strong>
                <br />
                Ein Blick auf frühere Sicherheitsprobleme kann Hinweise auf
                wiederkehrende oder potenzielle Risiken geben. <br />
                <br />
                <strong>Prozess- und Workflow-Analysen: </strong>
                <br />
                Kritische Abläufe im Unternehmen werden überprüft, um Risiken
                innerhalb der täglichen Arbeit oder Lieferketten zu
                identifizieren. <br />
                <br />
              </p>
            </div>
          </div>
        </div>

        <div className="white-section">
          <div className="container p-5">
            <div className="p-5 ">
              <h2 className="p-5">Threat Modeling</h2>
              <p className="col-lg-11 mx-auto">
                Für eine möglichst vollständige Risikoidentifikation
                wird ein Threat Modeling (eine Art Schritt-für-Schritt-Anweisung)
                eingesetzt. Threat Modeling identifiziert gezielt 
                Bedrohungen und stellt sicher, dass die anschließende
                Risikobewertung auf einer vollständigen und präzisen Analyse
                basiert.
                <br />
                <br />
                Threat Modeling umfasst in der Regel vier Schritte:
              </p>
              <p className="p-3 col-lg-10 text-start mx-auto">
                <section class="pt-5 text-start">
                  <ul class="timeline">
                    <li class="timeline-item mb-5">
                      <h5 class="fw-bold">1. Was wird geschützt?</h5>

                      <p>
                        Zuerst wird analysiert, was innerhalb des Systems oder
                        der Anwendung geschützt werden soll. Dies könnten
                        sensible Daten, bestimmte Funktionen oder wichtige
                        Prozesse sein. Dieser Schritt hilft, den Umfang der
                        Bedrohungsmodellierung festzulegen und die „Kronjuwelen“
                        des Systems zu identifizieren, die den größten
                        Schutzbedarf haben.
                      </p>
                    </li>
                    <li class="timeline-item mb-5">
                      <h5 class="fw-bold">
                        2. Was sind die potenziellen Bedrohungen?
                      </h5>

                      <p>
                        Anschließend wird analysiert, welche Bedrohungen
                        existieren und wie ein Angreifer auf das System
                        zugreifen könnte. Typische Bedrohungen könnten etwa
                        sein: Unbefugter Zugriff auf Daten{" "}
                        <Link to="/cybersecurity/3_5" className="icon-link">
                          {" "}
                          <svg className="bi" aria-hidden="true">
                            {" "}
                            <use xlinkHref="#book"></use>{" "}
                          </svg>{" "}
                          Man-in-the-Middle{" "}
                        </Link>{" "}
                        -Angriffe,{" "}
                        <Link to="/cybersecurity/3_4" className="icon-link">
                          {" "}
                          <svg className="bi" aria-hidden="true">
                            {" "}
                            <use xlinkHref="#book"></use>{" "}
                          </svg>{" "}
                          Denial-of-Service-Angriffe{" "}
                        </Link>{" "}
                        Schwachstellen in der Authentifizierung Verschiedene
                        Bedrohungsmodellierungs-Frameworks helfen hier,
                        Bedrohungen zu kategorisieren und zu analysieren.
                      </p>
                    </li>

                    <li class="timeline-item mb-5">
                      <h5 class="fw-bold">
                        3. Wie können diese Bedrohungen ausgenutzt werden?
                      </h5>

                      <p>
                        Dieser Schritt umfasst die Identifikation von
                        Schwachstellen, die ein Angreifer möglicherweise
                        ausnutzen könnte. Zum Beispiel könnte eine Anwendung
                        Schwachstellen in der Passwortverwaltung oder unsichere
                        Netzwerkschnittstellen haben, die Zugang zum System
                        ermöglichen. Hierbei werden auch Angriffspfade und
                        potenzielle Strategien des Angreifers analysiert, um die
                        realistische Bedrohungslage besser zu verstehen.
                      </p>
                    </li>

                    <li class="timeline-item mb-5">
                      <h5 class="fw-bold">
                        4. Welche Gegenmaßnahmen sind sinnvoll?
                      </h5>

                      <p>
                        Basierend auf den identifizierten Bedrohungen und
                        Schwachstellen werden - über die Risikoidentifikation hinausgehend und bereits als Element der Risikosteuerung zu betrachtende Schutzmaßnahmen und Strategien zur
                        Risikominimierung entwickelt. Gegenmaßnahmen können zum
                        Beispiel sein: Implementierung starker
                        Authentifizierungsmechanismen, Verschlüsselung sensibler
                        Daten,{" "}
                        <Link to="/cybersecurity/4_2#netzsegment" className="icon-link">
                          <svg className="bi" aria-hidden="true">
                            <use xlinkHref="#book"></use>
                          </svg>{" "}
                          Netzwerksegmentierung,
                        </Link>{" "}
                        Regelmäßige Schwachstellen-Scans und Systemupdates.
                      </p>
                    </li>
                  </ul>
                </section>
              </p>

            
              <h2 className="p-5"> Threat-Frameworks</h2>
              <p className="col-lg-11 text-center mx-auto">
                Es gibt mehrere Varianten des Threats Modelings.               Zwei bekannte Methoden in der
                Bedrohungsmodellierung sind das <strong>STRIDE-Modell </strong>{" "}
                und die <strong>Attack Trees </strong>(Angriffsbaum-Analyse).{" "}
                <br />
                <br />
              </p>
              <div className="col-lg-9 mx-auto">
                <ThreatFrameworks />
              </div>
              <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
                <img
                  src="/images/fact.svg"
                  alt="Transparent"
                  style={{
                    position: "relative",
                    maxWidth: "8%",
                    height: "auto",
                  }}
                />
                Microsoft verwendet Threat Modeling, um potenzielle
                Schwachstellen in neuen Produkten zu identifizieren. Zum
                Beispiel wird bei der Entwicklung von Office-Anwendungen
                geprüft, wie Angreifer manipulierte Dateien nutzen könnten, um
                Zugriff auf Systeme zu erhalten. Durch diese Identifikation
                werden Sicherheitslücken bereits in der Entwicklungsphase
                geschlossen.
              </p>
             <p className="col-lg-11 p-5 mx-auto">
            Das untenstehende kleine interaktive Lerntool zeigt, wie Risikoidentifikation in der Cybersecurity in der Praxis funktioniert. Dabei ist es didaktisch vereinfacht und soll vor allem die Grundidee vermitteln: <br />
<strong>Unterschiedliche Methoden </strong>(Workshop, Checkliste, Scan, Vorfälle, Prozessanalyse, Threat Modeling) finden nicht automatisch dieselben Risiken. Wenn du Methoden aktivierst, füllt sich ein „Risikoregister“ mit typischen Risiken, die man mit dieser Methode häufig entdeckt. So wird sichtbar, warum ein guter Identifikationsprozess mehrere Perspektiven kombiniert.
<br />
              <br />
Anschließend ordnest du die gefundenen Risiken mit <strong>STRIDE </strong> ein (Spoofing, Tampering, Repudiation, Information Disclosure, DoS, Elevation of Privilege). Das trainiert, Bedrohungen systematisch zu kategorisieren – wie eine Denk-Checkliste.
<br />
              <br />
Zum Schluss kommt eine kleine <strong>Attack-Tree-Übung </strong>: Entscheide, welche Angriffspfade grundsätzlich plausibel sind. Das soll dir helfen, nicht nur „ein einzelnes Risiko“ zu sehen, sondern mehrere mögliche Wege, wie ein Ziel erreicht werden könnte.</p><RiskIdentificationLab />
            </div>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="container ">
          <div
            className="safe rounded-2 text-center"
            style={{ backgroundColor: "#fec748" }}
          >
            <img
              src="/images/abwehr.svg"
              alt="Abwehr"
              style={{
                position: "relative",
                maxWidth: "7%",
                height: "auto",
              }}
            />

            <h3 className="p-5">
              {" "}
              Best Practices für die Risikoidentifikation
            </h3>

            <p className="col-lg-11 mx-auto">
              <strong>Regelmäßige Schwachstellen-Scans: </strong>
              <br />
              Mindestens monatliche Scans identifizieren neu entdeckte
              Schwachstellen in Systemen und Anwendungen. <br />
              <br />
              <strong>Bedrohungssimulationen: </strong>
              <br />
              Durch <strong>Red-Teaming </strong> oder Simulationen können
              realistische Angriffsszenarien durchgespielt werden, um
              Schwachstellen in Prozessen und Technologien aufzudecken.
              Red-Teaming ist eine Methode der Cybersecurityprüfung, bei der
              ein Team (das sogenannte „Red Team“) die Rolle eines Angreifers
              übernimmt, um Schwachstellen in der Sicherheitsinfrastruktur eines
              Unternehmens aufzudecken. Ziel ist es, reale Bedrohungsszenarien
              zu simulieren und zu prüfen, wie effektiv die Sicherheitsmaßnahmen
              des Unternehmens (das „Blue Team“) auf diese Angriffe reagieren
              können.
              <br />
              <br />
              <strong>Integrierte Risikoübersicht: </strong>
              <br />
              Die Verwendung von Tools wie{" "}
              <Link to="/cybersecurity/4_3#siem" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                SIEM (Security Information and Event Management)
              </Link>{" "}
              ermöglicht es, Daten aus verschiedenen Quellen zusammenzuführen
              und eine zentrale Risikoübersicht zu schaffen.
              <br />
              <br />
              <strong>Mitarbeitereinbindung: </strong>
              <br />
              Programme zur Sensibilisierung der Mitarbeiter tragen dazu bei,
              dass diese potenzielle Risiken in ihrem Arbeitsumfeld besser
              erkennen können.
            </p>
             
             
          </div> 
        </div>

        {/* Fragenteil */}
        <div className="container pt-5 my-5">
          <div className="text-center m-4">
            <h2>Überprüfe dein Wissen</h2>
            <p className="col-lg-11 mx-auto">
              Mit den richtigen Antworten kommst du weiter!
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-10 text-start">
              <form onSubmit={handleSubmit}>
                {questions.map((question, index) => (
                  <div key={index} className="mb-4">
                    <p className="fs-4">{question.question}</p>{" "}
                    {question.options.map((option) => (
                      <div key={option.value} className="form-check">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          name={`question${index}`}
                          value={option.value}
                          checked={selectedAnswers[index] === option.value}
                          onChange={() =>
                            handleAnswerChange(index, option.value)
                          }
                        />
                        <label className="form-check-label fs-5">
                          {option.label}
                        </label>{" "}
                      </div>
                    ))}
                  </div>
                ))}
                {error && <p className="text-danger">{error}</p>}
                <div className="text-center">
                  <button type="submit" className="btn btn-primary">
                    überprüfen
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* Ende Fragenteil */}
    </div>
  );
};

export default Chapter7_2;
